import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { corporateCMSApi } from "~/Services";

interface MainContent {
  id: number;
  field_our_client_text: string;
  field_our_client_text_ms: string;
  field_our_client_text_zhans: string;
  field_local_en: string;
  field_local_ms: string;
  field_local_zh: string;
  field_international_en: string;
  field_international_ms: string;
  field_international_zh: string;
  published: boolean;
  created_at: string;
  updated_at: string;
}

interface LocalClients {
  id: number;
  title: string;
  field_local_client_ms: string;
  field_local_client_zh: string;
  field_local_order_sequence: number;
  published: boolean;
  created: string;
  updated_at: string;
}

interface InternationalClients {
  id: number;
  title: string;
  field_international_title_ms: string;
  field_international_title_zh: string;
  field_international_order_sequen: number;
  published: boolean;
  created_at: string;
  updated_at: string;
}

const useMainContent = (
  options?: UseQueryOptions<MainContent, DefaultError, MainContent, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<MainContent, DefaultError> => {
  return useQuery<MainContent, DefaultError, MainContent, QueryKey>(
    {
      queryKey: ["mainContent"],
      enabled: false,
      queryFn: async (): Promise<MainContent> => {
        const response = await corporateCMSApi.get<any>(`/api/client-header-data/all-fields`);
        return response.data[0];
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

const useLocalClients = (
  id: string,
  options?: UseQueryOptions<LocalClients, DefaultError, LocalClients, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<LocalClients, DefaultError> => {
  return useQuery<LocalClients, DefaultError, LocalClients, QueryKey>(
    {
      queryKey: ["localClients", id],
      enabled: false,
      queryFn: async (): Promise<LocalClients> => {
        const response = await corporateCMSApi.get<any>(`/api/local-client-details/all-fields/${id}`);
        return response.data[0];
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

const useInternationalClients = (
  id: string,
  options?: UseQueryOptions<InternationalClients, DefaultError, InternationalClients, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<InternationalClients, DefaultError> => {
  return useQuery<InternationalClients, DefaultError, InternationalClients, QueryKey>(
    {
      queryKey: ["internationalClients", id],
      enabled: false,
      queryFn: async (): Promise<InternationalClients> => {
        const response = await corporateCMSApi.get<any>(`/api/international-clients-data/all-fields/${id}`);
        return response.data[0];
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useInternationalClients, useLocalClients, useMainContent };
